import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as utilities from './utilities';
import Message from './message';
import Growl from '@ux/growl';


/**
 * Render Growl component and set messageData.
 *
 * @class OrderConfirmation
 * @public
 *
 * @returns {React.ReactElement} Growl Component
 */

export default class OrderConfirmation extends Component {
  componentDidMount() {
    const orderId = utilities.getOrderIdFromCookie() || utilities.getOrderIdFromQuerystring(global) || this.props.orderId;

    if (orderId) {
      const messageData = utilities.getMessageDataFromCookie(orderId);

      if (messageData) {
        utilities.deleteOrderIdCookie(global);
        utilities.deleteMessageDataCookie(global, orderId);

        if (messageData.orderData) {
          utilities.captureEcomEvent(global, messageData.orderData);
        }

        if (messageData.message) {
          Growl.addGrowlMessage({
            title: messageData.message.title,
            content: <Message { ...messageData.message } />,
            icon: 'success',
            fade: false
          });
        }
      }
    }
  }

  render() {
    return <Growl />;
  }
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */

OrderConfirmation.propTypes = {
  /** Individual order identifier */
  orderId: PropTypes.string
};
